var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b',[_vm._v(_vm._s(_vm.item.name))]),_vm._v(" "),(_vm.item.security_id > 0)?_c('span',{staticClass:"badge badge-danger",style:({'background-color' : _vm.roles[_vm.item.security_id].colour})},[_vm._v(_vm._s(_vm.roles[_vm.item.security_id].name))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }